<template>
  <div class="grow">
    <div class="st-window">
      <div class="header">
        <span class="text">{{ $t('stranger.data.sections.envelopes') }}</span>
        <div class="close-button">
          <button class="st-button" @click="close()">X</button>
        </div>
      </div>

      <!-- START -->
      <div class="content" v-if="step==='choose'">
        <img src="/stranger/assets/images/ST_PIXELART_VELO.png">
        <div class="coordinates-title">{{ $t('stranger.envelopes.title') }}</div>
        <div class="coordinates">{{ $t('stranger.envelopes.coordinates') }}</div>
        <div v-if="error !== ''" class="st-error st-blink">{{ error }}</div>
        <div class="form">
          <div>
            <input type="text" v-model="coordinates"  v-on:keyup.enter="submit('choose')" :placeholder="$t('stranger.envelopes.coordinates_help')">
          </div>
          <div>
            <button class="st-button" @click="submit('choose')">{{ $t('common.buttons.ok') }}</button>
          </div>          
        </div>
        <div>
          <div class="place-title" v-if="found_places.length > 0">{{ $t('stranger.envelopes.already_found') }}</div>
          <div class="place-link" v-for="p in found_places" v-bind:key="p.code" @click="goTo(p.code)">
            <span>{{ $t('stranger.envelopes.env-' + p.env + '.name') }}</span>
          </div>
        </div>
      </div>

      <!-- ENV A -->
      <div class="content" v-if="step.startsWith('env-A')">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div v-if="getEnvelopeSolved('A')">
          <div class="step-text">{{ $t('stranger.envelopes.env-A.outcome_1') }}</div>
          <div class="step-text outcome">{{ $t('stranger.envelopes.env-A.outcome_2') }}</div>          
        </div>         
        <div v-else-if="step==='env-A1'">
          <div class="step-text">{{ $t('stranger.envelopes.env-A.title_1') }}</div>
          <div v-if="error !== ''" class="st-error">{{ error }}</div>
          <div>
            <select v-model="listSelection" class="st-select">
              <option v-for="entry in getList('listStreets').entries" :key="entry" :value="entry">
                {{ entry }}
              </option>
            </select> 
          </div>
          <div>
            <button class="st-button" @click="submit('A1')">{{ $t('common.buttons.ok') }}</button>
          </div>           
        </div>
        <div v-else-if="step==='env-A2'">
          <div class="step-text">{{ $t('stranger.envelopes.env-A.title_2') }}</div>
          <div v-if="error !== ''" class="st-error">{{ error }}</div>
          <div>
            <select v-model="listSelection" class="st-select">
              <option v-for="entry in getList('listStreetNumbers').entries" :key="entry" :value="entry">
                {{ entry }}
              </option>
            </select> 
          </div>
          <div>
            <button class="st-button" @click="submit('A2')">{{ $t('common.buttons.ok') }}</button>
          </div>           
        </div>
      </div> 
      
      <!-- ENV B -->
      <div class="content" v-if="step.startsWith('env-B')">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div v-if="getEnvelopeSolved('B')">
          <div class="step-text">{{ $t('stranger.envelopes.env-B.outcome_1') }}</div>
          <div class="step-text outcome">{{ $t('stranger.envelopes.env-B.outcome_2') }}</div>          
        </div>         
        <div v-else-if="step==='env-B1'">
          <div class="step-text">{{ $t('stranger.envelopes.env-B.name') }}</div>
          <div class="step-text">{{ $t('stranger.envelopes.env-B.title_2') }}</div>          
          <div v-if="error !== ''" class="st-error">{{ error }}</div>
          <div class="form">
              <input type="text" class="mb-3" v-model="listSelection"  v-on:keyup.enter="submit('B1')" :placeholder="$t('stranger.envelopes.env-B.help')">
          </div>
          <div>
            <button class="st-button" @click="submit('B1')">{{ $t('common.buttons.ok') }}</button>
          </div>           
        </div>
      </div>
      
      <!-- ENV C -->
      <div class="content" v-if="step.startsWith('env-C')">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div v-if="getEnvelopeSolved('C')">
          <div class="step-text">{{ $t('stranger.envelopes.env-C.outcome_2') }}</div>
          <div class="step-text outcome">{{ $t('stranger.envelopes.env-C.outcome_1') }}</div>          
        </div>         
        <div v-else-if="step==='env-C1'">
          <div class="step-text">{{ $t('stranger.envelopes.env-C.title_2') }}</div>      
          <div v-if="error !== ''" class="st-error">{{ error }}</div>
          <div class="form">
              <input type="text" class="mb-3" v-model="listSelection"  v-on:keyup.enter="submit('C1')" :placeholder="$t('stranger.envelopes.env-C.help')">
          </div>
          <div>
            <button class="st-button" @click="submit('C1')">{{ $t('common.buttons.ok') }}</button>
          </div>           
        </div>
      </div>   
      
      <!-- ENV D -->
      <div class="content" v-if="step.startsWith('env-D')">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div class="bbs-chat" v-if="getEnvelopeSolved('D')">
          <div><img class="bbs-logo" src="/stranger/assets/images/ST_LOGO_BBS.png" /></div>
          <div><span class="bbs-time">{{ $t('stranger.envelopes.env-D.bbs_time_1') }}</span><span class="bbs-sender-1">{{ $t('stranger.envelopes.env-D.sender_1') }}</span></div>
          <div class="step-text" v-html="$t('stranger.envelopes.env-D.title_4')"></div>
          <div class="step-text"><span class="bbs-time">{{ $t('stranger.envelopes.env-D.bbs_time_2') }}</span><span class="bbs-sender-2">{{ $t('stranger.envelopes.env-D.sender_2') }}</span></div>
          <div class="step-text" v-html="$t('stranger.envelopes.env-D.title_5')"></div>
          <div class="mt-3"><span class="bbs-time">{{ $t('stranger.envelopes.env-D.bbs_time_3') }}</span><span class="bbs-sender-1">{{ $t('stranger.envelopes.env-D.sender_1') }}</span></div>
          <div class="step-text" v-html="$t('stranger.envelopes.env-D.outcome_1')"></div>              
          <div class="step-text outcome">{{ $t('stranger.envelopes.env-D.outcome_2') }}</div>          
        </div>         
        <div v-else-if="step==='env-D1'">
          <div><img class="school-logo" src="/stranger/assets/images/ST_LOGO_HAWKINS.png" /></div>
          <div class="step-text">{{ $t('stranger.envelopes.env-D.name') }}</div>
          <div class="step-text">{{ $t('stranger.envelopes.env-D.title_2') }}</div>          
          <div v-if="error !== ''" class="st-error">{{ error }}</div>
          <div>
            <select v-model="listSelection" class="st-select">
              <option v-for="entry in getList('listPlaces').entries" :key="entry" :value="entry">
                {{ $t(`stranger.envelopes.lists.listPlaces.${entry}`) }}
              </option>
            </select> 
          </div>
          <div>
            <button class="st-button" @click="submit('D1')">{{ $t('common.buttons.ok') }}</button>
          </div>       
        </div>
        <div v-else-if="step==='env-D2'"  class="bbs-chat">
          <div><img class="bbs-logo" src="/stranger/assets/images/ST_LOGO_BBS.png" /></div>
          <div class="step-text">{{ $t('stranger.envelopes.env-D.title_3') }}</div>
          <div v-if="error !== ''" class="st-error">{{ error }}</div>
          <div>
            <select v-model="listSelection" class="st-select">
              <option v-for="entry in getList('listChats').entries" :key="entry" :value="entry">
                {{ entry }}
              </option>
            </select> 
          </div>
          <div>
            <button class="st-button" @click="submit('D2')">{{ $t('common.buttons.ok') }}</button>
          </div>          
        </div>
        <div v-else-if="step==='env-D3'" class="bbs-chat">
          <div><img class="bbs-logo" src="/stranger/assets/images/ST_LOGO_BBS.png" /></div>
          <div><span class="bbs-time">{{ $t('stranger.envelopes.env-D.bbs_time_1') }}</span><span class="bbs-sender-1">{{ $t('stranger.envelopes.env-D.sender_1') }}</span></div>
          <div class="step-text" v-html="$t('stranger.envelopes.env-D.title_4')"></div>
          <div v-if="error !== ''" class="st-error">{{ error }}</div>
          <div>
            <select v-model="listSelection" class="st-select">
              <option v-for="entry in getList('listSuspects').entries" :key="entry" :value="entry">
                {{ entry }}
              </option>
            </select> 
          </div>
          <div>
            <button class="st-button" @click="submit('D3')">{{ $t('common.buttons.ok') }}</button>
          </div>          
        </div>        
      </div>  

      <!-- ENV E -->
      <div class="content" v-if="step.startsWith('env-E')">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div v-if="getEnvelopeSolved('E')">
          <div class="step-text">{{ $t('stranger.envelopes.env-E.outcome_1') }}</div>
          <div class="step-text outcome">{{ $t('stranger.envelopes.env-E.outcome_2') }}</div>
        </div>
        <div v-else-if="step==='env-E2'">
          <div class="step-text">{{ $t('stranger.envelopes.env-E.name') }}</div>
          <div class="step-text">{{ $t('stranger.envelopes.env-E.title_1') }}</div>
          <Digicode :correctCode="$strangerStore.getEnvelope('E').config.correct.toUpperCase()" @onCodeSuccess="submit('E2')"/>
        </div>
      </div>

      <!-- Family video -->
      <div class="content" v-if="step.startsWith('env-VF')">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div>
          <div class="step-text">{{ $t('stranger.envelopes.env-VF.name') }}</div>
          <div class="step-text">{{ $t('stranger.envelopes.env-VF.outcome_1') }}</div>
          <div class="step-text outcome">{{ $t('stranger.envelopes.env-VF.outcome_2') }}</div>
        </div>
      </div>


      <!-- ENV F -->
      <div class="content" v-if="step.startsWith('env-F')">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div v-if="getEnvelopeSolved('F')">
          <div class="step-text">{{ $t('stranger.envelopes.env-F.outcome_1') }}</div>  
          <div class="step-text outcome">{{ $t('stranger.envelopes.env-F.outcome_2') }}</div>
          <div class="step-text outcome">{{ $t('stranger.envelopes.env-F.outcome_3') }}</div>          
        </div>         
        <div v-else-if="step==='env-F1'">
          <div class="step-text">{{ $t('stranger.envelopes.env-F.name') }}</div>
          <div class="step-text">{{ $t('stranger.envelopes.env-F.title_2') }}</div>          
          <div v-if="error !== ''" class="st-error">{{ error }}</div>
          <div>
            <select v-model="listSelection" class="st-select">
              <option v-for="entry in getList('listFloors').entries" :key="entry" :value="entry">
                {{ entry }}
              </option>
            </select> 
          </div>
          <div>
            <button class="st-button" @click="submit('F1')">{{ $t('common.buttons.ok') }}</button>
          </div>
        </div>
        <div v-else-if="step==='env-F2'">
          <div class="step-text">{{ $t('stranger.envelopes.env-F.title_3') }}</div>
          <div v-if="error !== ''" class="st-error">{{ error }}</div>
          <div>
            <select v-model="listSelection" class="st-select">
              <option v-for="entry in getList('listSectors').entries" :key="entry" :value="entry">
                {{ entry }}
              </option>
            </select> 
          </div>
          <div>
            <button class="st-button" @click="submit('F2')">{{ $t('common.buttons.ok') }}</button>
          </div>           
        </div>
      </div>       
      
      <!-- ENV G -->
      <div class="content" v-if="step.startsWith('env-G')">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div v-if="getEnvelopeSolved('G')">
          <div class="step-text">{{ $t('stranger.envelopes.env-G.outcome_1') }}</div>
          <div class="step-text outcome">{{ $t('stranger.envelopes.env-G.outcome_2') }}</div>          
        </div>         
      </div>       

      <!-- Q12 -->
      <div class="content" v-if="step === 'env-de-Q12'">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div>
          <div class="step-text">{{ $t('stranger.envelopes.env-de-Q12.outcome_1') }}</div>      
        </div>         
      </div>  
      
      <!-- N19 -->
      <div class="content" v-if="step === 'env-de-N19'">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div>
          <div class="step-text">{{ $t('stranger.envelopes.env-de-N19.outcome_1') }}</div>      
        </div>         
      </div>   
      
      <!-- T7 -->
      <div class="content" v-if="step === 'env-de-T7'">
        <div class="button-back">
          <button class="st-button" @click="back()"><img src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
        </div>
        <div>
          <div class="step-text">{{ $t('stranger.envelopes.env-de-T7.outcome_1') }}</div>      
        </div>         
      </div>        
    </div>    
  </div>
</template>
  
<script>
  import Digicode from "@/components/stranger/Digicode";
  import currentGameMixin from "@/mixins/currentGameMixin";


  export default {
    name: "Envelopes",

    components: {
      Digicode
    },

    mixins: [currentGameMixin],

    data: () => ({
      showError: false,
      error: '',
      coordinates: '',
      listSelection: '',
      step: 'choose'
    }),

    methods: {
      close() {
        this.$router.push({ name: 'stranger-home' });
      },
      getEnvelopeSolved(envelope)
      {
        return this.$strangerStore.getEnvelope(envelope).solved === true;
      },
      getList(listName)
      {
        return this.$strangerStore.envelopes.lists.find((p) => p.id === listName);
      },    
      back() {
        this.error = '';
        this.coordinates = '';
        this.step = 'choose';
      },
      goTo(code) {
        this.step = 'choose';
        this.coordinates = code;
        this.submit(this.step);
      },
      nextStep(nextStep) {
        this.step = nextStep;
        this.error = '';
        this.listSelection = '';
      },
      submit(step) {
        this.error = '';

        switch(step) {
          case '':
          case 'choose': {
            if (this.coordinates.trim() === '') return;

            const place = this.$strangerStore.envelopes.places.find((p) => p.code === this.coordinates.toUpperCase());
            if (place) {
              this.listSelection = '';
              this.step = place.next_step;

              if (!place.found) {
                this.$strangerStore.envelopes.places.find((p) => p.code === this.coordinates.toUpperCase()).found = true;
                this.$strangerStore.saveState();
              }

              if (this.step === 'env-G1') {
                this.$strangerStore.solveEnvelope('G');
              }
              if (this.step === 'env-VF') {
                this.$strangerStore.enableEvidence('videoclub');
              }
            } else {
              this.error = this.$t('stranger.envelopes.not_found');
            }
            break;
          }
          case 'A1':
            if (this.listSelection === this.$strangerStore.getEnvelope('A').config.correct_1) {
              this.nextStep('env-A2');
            } else {
              this.error = this.$t('stranger.envelopes.not_found');
              this.listSelection = '';
            }
            break;
          case 'A2':
            if (this.listSelection === this.$strangerStore.getEnvelope('A').config.correct_2) {
              this.nextStep('env-A');
              this.$strangerStore.solveEnvelope('A');
            } else {
              this.error = this.$t('stranger.envelopes.not_found');
              this.listSelection = '';
            }
            break;
          case 'B1':
            if (this.listSelection.trim().toUpperCase() === this.$strangerStore.getEnvelope('B').config.correct_1.toUpperCase()) {
              this.nextStep('env-B');
              this.$strangerStore.solveEnvelope('B');
            } else {
              this.error = this.$t('stranger.envelopes.env-B.error');
              this.listSelection = '';
            }
            break;  
          case 'C1':
            if (this.listSelection.trim().toUpperCase() === this.$strangerStore.getEnvelope('C').config.correct.toUpperCase()) {
              this.nextStep('env-C');
              this.$strangerStore.solveEnvelope('C');
            } else {
              this.error = this.$t('stranger.envelopes.env-C.error');
              this.listSelection = '';
            }
            break;  
          case 'D1':
            if (this.listSelection === this.$strangerStore.getEnvelope('D').config.correct_1) {
              this.nextStep('env-D2');
            } else {
              this.error = this.$t('stranger.envelopes.env-D.error_1');
              this.listSelection = '';
            }
            break;
          case 'D2':
            if (this.listSelection === this.$strangerStore.getEnvelope('D').config.correct_2) {
              this.nextStep('env-D3');
            } else {
              this.error = this.$t('stranger.envelopes.env-D.error_1');
              this.listSelection = '';
            }
            break;
          case 'D3':
            if (this.listSelection === this.$strangerStore.getEnvelope('D').config.correct_3) {
              this.nextStep('env-D');
              this.$strangerStore.solveEnvelope('D');
            } else {
              this.error = this.$t('stranger.envelopes.env-D.error_2');
              this.listSelection = '';
            }
            break;
          case 'E1AP':
            this.nextStep('env-E2');
            break;                                                     
          case 'E2':
              this.nextStep('env-E');
              this.$strangerStore.solveEnvelope('E');
            break;             
          case 'F1':
            if (this.listSelection === this.$strangerStore.getEnvelope('F').config.correct_1) {
              this.nextStep('env-F2');
            } else {
              this.error = this.$t('stranger.envelopes.not_found');
              this.listSelection = '';
            }
            break;
          case 'F2':
            if (this.listSelection === this.$strangerStore.getEnvelope('F').config.correct_2) {
              this.nextStep('env-F');
              this.$strangerStore.enableEvidence('talkiewalkie');
              this.$strangerStore.solveEnvelope('F');
            } else {
              this.error = this.$t('stranger.envelopes.not_found');
              this.listSelection = '';
            }
            break;                                 
        }
      },
    },

    watch: {
    },

    computed: {
      found_places: function() {
        return this.$strangerStore.envelopes.places.filter((p) => p.found === true)
      }

    },
    created() { }
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/css/stranger.scss';
 
  .st-window {
    .content {
      img {
        max-width: 180px;
      }

      img.school-logo {
        max-width: 300px;
        margin-top: 10px;
        margin-bottom: 20px;
      }

      .st-button img {
        width: 32px;
        padding-top:2px;
        height: 40px;
      }    
      
      .button-back {
        text-align: left;
      }      

      .coordinates-title, .coordinates, .step-text {
        margin-top: 24px;
        color: #fff;
      }

      .bbs-chat {
        text-align: left;

        .bbs-time {
          color: #999999;
          margin-right: 10px;
        }

        .bbs-sender-1 {
          color: $accent-color;
          text-transform: uppercase;
        }

        .bbs-sender-2 {
          color: $accent2-color;
          text-transform: uppercase;
        }

        .step-text {
          margin-top: 10px;
        }

        img.bbs-logo {
          max-width: 300px;
          margin-top: 10px;
          margin-bottom: 20px;
        }

      }


      .place-title {
        margin-top: 24px;
        margin-bottom: 8px;
        color: #999;
      }

      .place-link {
        color: $light-color;
        margin-top: 6px;

        & span:hover {
          cursor: pointer;
          color: $accent-color;
        }
      }

      .st-error {
        color: $error-color;
        margin-bottom: 12px;
        margin-top: 12px;
      }

      .outcome {
        padding: 6px;
        background: #000;
        color: #f00;
      }

      .form {
        padding-top: 12px;

        input[type="text"] {
          border: 2px solid #fff;
          border-radius: 0;
          background: #ccc;
          color: #000;
          padding: 8px;
          font-size: 16px;
        }

        .st-button {
          margin-top: 12px;
          padding-top: 2px;
        }
      }

      .st-select {
        margin-top: 12px;
        margin-bottom: 12px;
      }
    }
  }

  @media (max-width: 600px) {
    .st-window .form input[type="text"]  {
      width: 100%;
    }
  }

</style>
  